import { useContext, useEffect } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import { applyBrandingFromSession } from "../utils/brandingSession";

/**
 * Restores published branding colors on unauthenticated routes (e.g. /logout)
 * from sessionStorage saved at config load or sign-out.
 */
const BrandingSessionBootstrap = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  useEffect(() => {
    applyBrandingFromSession(theme, setTheme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default BrandingSessionBootstrap;
